import logo from "../../../assets/imgs/ventionlablogo.png";

const DefaultFooter = (props) => {
    return (
        <div className="text-xs p-0 md:p-4 text-white">
            <div className="">
                <div className="flex flex-row justify-between">
                    <div>Benchmarker Assets</div>
                    <div>v{process.env.REACT_APP_VERSION}</div>
                </div>
                <div className="flex flex-row text-xs sm:text-xs pt-4 gap-x-1 sm:gap-x-2 items-center justify-between">
                    <a
                        className="flex items-center"
                        href="https://www.ventionlab.tech/"
                    >
                        <img className="w-6" src={logo} alt={"VentionLab"} />
                        &nbsp;Vention Lab
                    </a>{" "}
                    &copy; {new Date().getFullYear()} Vention Lab
                </div>
            </div>
        </div>
    );
};

export default DefaultFooter;
